itsoftApp.createModule("filters", function () {
    const module = this;
 
    const init = function (filtersSection, cb) {
        const filtersForm = filtersSection.querySelector(".js-filters");
        const filtersBlocks = filtersSection.querySelectorAll(".js-filter-block");
        const filtersAllItemsWithoutAllButton = filtersSection.querySelectorAll(".js-filter-item:not(.js-filter-item--all)");

        const resetAllFilters = function (cb) {
          Array.prototype.forEach.call(filtersAllItemsWithoutAllButton, function (item) {
            item.checked = false;
          });

          cb();
        }

        let filtersNameMap = {};

        const initFilterBlock = function (filterBlock) {
            const filtersItems = filterBlock.querySelectorAll(".js-filter-item");
            const filtersAllItem = filterBlock.querySelector(".js-filter-item--all");
            const filtersItemsWithoutAll = filterBlock.querySelectorAll(".js-filter-item:not(.js-filter-item--all)");
            const filtersLabels = filterBlock.querySelectorAll(".js-filter-label");
            const resetButton = filterBlock.querySelector(".js-reset-button");
            const filterName = filtersItems.length > 0 && filtersItems[0].name;

            const changeFilter = function () {
              const checkedFilters = Array.prototype.filter.call(filtersItemsWithoutAll, item => item.checked);

              if (filtersAllItem) {
                if (checkedFilters.length > 0) {
                  filtersAllItem.disabled = false;
                  filtersAllItem.removeAttribute("checked");
                  filtersAllItem.checked = false;
                } else {
                  filtersAllItem.disabled = true;
                  filtersAllItem.checked = true;
                }
              }
            }

            const isAllButton = function (filterItem) {
              return filterItem.classList.contains("js-filter-item--all") ? true : false;
            }

            // const resetFilters = function () {
            //   if (filtersAllItem) {
            //     filtersAllItem.checked = true;
            //     filtersAllItem.disabled = true;
            //   }

            //   Array.prototype.forEach.call(filtersItemsWithoutAll, function (item) {
            //     item.checked = false;
            //   });

            //   createRequest();
            // }

            const resetFilters = function () {
              resetAllFilters(createRequest);
            }

            const createRequest = function () {
              let allFiltersValues = [];

              allFiltersValues = Array.prototype.reduce.call(filtersBlocks, function (acc, filterBlock) {
                  const allFiltersItems = filterBlock.querySelectorAll(".js-filter-item") || [];
                  const allCheckedFilters = Array.prototype.filter.call(allFiltersItems, item => item.checked) || [];

                  if (allCheckedFilters.length > 0) {
                      acc.push({
                          name: filterBlock.getAttribute("name") || filterBlock.getAttribute("data-name") || allCheckedFilters[0].name,
                          value: Array.prototype.map.call(allCheckedFilters, (checkedFilter) => checkedFilter.value)
                      });
                  }
                  
                  return acc;
              }, []);

              debouncer(allFiltersValues);
            }

            module.createRequest = createRequest

            const entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;'
            };

            const escapeHtml = function (string) {
                return String(string).replace(/[&<>"'`=\/]/g, function (s) {
                    return entityMap[s];
                });
            }

            const sendRequest = function (allFiltersValues) {  
              let url = "?";

              if (allFiltersValues.length === 0) {
                url = "";
              }
  
              Array.prototype.forEach.call(allFiltersValues, function (filterValue, index, arr) {
                const selectName = filterValue.name;
                const selectValue = filterValue.value.join(';');

                url += selectName + "=" + selectValue;

                if (index < arr.length - 1) {
                  url += '&';
                }
              });
  
              // if (url !== "") {
                url = escapeHtml(url);
                url.replace(/\s/g, '+');
    
                const action = filtersForm.getAttribute("action");
    
                const query = action + url;
    
                history.pushState("", "", url);
    
                cb(null, query);
              // }
            }

            const debouncer = itsoftApp.utils.debouncer(sendRequest, 500);

            resetButton && resetButton.addEventListener("click", resetFilters);

            Array.prototype.forEach.call(filtersItems, function (filterItem, index) {
              filterItem.addEventListener("change", function (evt) {
                const target = evt.currentTarget;
                if (isAllButton(filterItem)) {
                  resetFilters();
                  return;
                }

                changeFilter(target);
                createRequest();
              });
            });

            if (filterName && filtersNameMap[filterName]) {
              Array.prototype.forEach.call(filtersNameMap[filterName], function (filterValue) {
                  const filterItem = filterBlock.querySelector('[value="' + filterValue + '"]');
                  if (filterItem) {
                    filterItem.checked = true;
                  }
              });
            }

            /* --- */

            Array.prototype.forEach.call(filtersLabels, function (filtersLabel) {
                filtersLabel.addEventListener("keyup", function (evt) {
                    if (evt.keyCode !== 13) {
                        return;
                    }

                    const target = evt.currentTarget;
                    const filterItem = target.closest(".js-filter-wrapper").querySelector(".js-filter-item");

                    if (isAllButton(filterItem)) {
                      resetFilters();
                      return;
                    }

                    if (filterItem.checked) {
                      filterItem.removeAttribute("checked");
                      filterItem.checked = false
                    } else {
                      filterItem.checked = true;
                    }

                    changeFilter(filterItem);
                    createRequest();
                });
            });
        }

        const url = window.location.href

        const parseFiltersFromUrl = function (url) {
          // 1. Получаем часть после '?'
          const queryString = url.split('?')[1];
          if (!queryString) return {};

          // 2. Делим по '&' на отдельные параметры
          const params = queryString.split('&');

          const filtersObj = {};

          params.forEach(param => {
            // 3. Делим каждый параметр на ключ и значение по '='
            const [key, value] = param.split('=');
            if (!key || !value) return;

            // 4. Делим значение по ';' и сохраняем в объект
            filtersObj[key] = value.split(';');
          });

          return filtersObj;
        }

        filtersNameMap = parseFiltersFromUrl(url);

        Array.prototype.forEach.call(filtersBlocks, function (filterBlock) {
            initFilterBlock(filterBlock);
        });

        module.createRequest();
     }
 
    // module.callback = initFilters;/
    module.init = init;
 });